import React from "react";
import ContentLoader from 'react-content-loader'

const SummaryLoader = props => (
    <ContentLoader
        speed={props.speed ? props.speed : 1}
        width={props.width}
        height={props.width}
        viewBox={`0 0 ${props.width} ${props.height}`}
        overflow="hidden"
        backgroundColor="#eaeced"
        foregroundColor="#ffffff"
        {...props}
    >
        <rect x="144" y="0" rx="5" ry="5" width="362" height="39" />
        <rect x="0" y="39" rx="5" ry="5" width="140" height="43" />
        <rect x="0" y="89" rx="5" ry="5" width="500" height="25" />
        <rect x="0" y="126" rx="5" ry="5" width="500" height="25" />
        <rect x="143" y="53" rx="5" ry="5" width="75" height="29" />
        <rect x="221" y="53" rx="5" ry="5" width="125" height="29" />
        <rect x="0" y="163" rx="5" ry="5" width="500" height="25" />
        <rect x="0" y="200" rx="5" ry="5" width="500" height="25" />
    </ContentLoader>
)

export default SummaryLoader